import { render } from "./ChangesHistoryList.vue?vue&type=template&id=2ea784c3&scoped=true&ts=true"
import script from "./ChangesHistoryList.vue?vue&type=script&lang=ts"
export * from "./ChangesHistoryList.vue?vue&type=script&lang=ts"

import "./ChangesHistoryList.vue?vue&type=style&index=0&id=2ea784c3&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea784c3"]])

export default __exports__